export default class DragScroll {
  constructor(node) {
    this.node = node;
    this.dragInfo = {
      isMove: false,
      isMoveDowN: false,
      initScrollX: 0,
      initClientX: 0,
    }
    this.init()
  }
  init() {
    this.mouseup = this.mouseup.bind(this);
    this.mousedown = this.mousedown.bind(this);
    this.mousemove = this.mousemove.bind(this);
    this.node.addEventListener('mousedown', this.mousedown, false)
    window.document.body.addEventListener('mouseup', this.mouseup, false)
  }
  //鼠标按下
  mousedown(e) {
    e.stopPropagation();
    this.dragInfo.isMouseDown = true;
    this.dragInfo.initClientX = e.clientX;
    this.dragInfo.initScrollX = this.node.scrollLeft;
    this.node.addEventListener('mousemove', this.mousemove, false)
  }
  //鼠标抬起
  mouseup() {
    this.dragInfo.isMove = false;
    this.dragInfo.isMouseDown = false;
    this.node.removeEventListener('mousedown', this.mousedown, false)
    this.node.removeEventListener('mousemove', this.mousemove, false)
    this.node.addEventListener('mousedown', this.mousedown, false)
  }
  //鼠标移动
  mousemove(e) {
    if (this.dragInfo.isMouseDown) {
      e.preventDefault()
      const scrollX = e.clientX - this.dragInfo.initClientX;
      this.node.scrollTo(this.dragInfo.initScrollX - scrollX, 0)
      this.dragInfo.isMove = true;
    }
  }
}